export const COOKIE_NAME = 'ttsmm-web-state';
export const TT_ID = 285920;
export const HARMONY_ID = '2571814511';
export const MODMANAGER_ID = '2790161231';
